import styled from 'styled-components';
import { BodyHeavy, TextSkeleton } from '@pelando/components';

export const StoreRatingContainer = styled.div`
  color: rgb(${({ theme }) => theme.colors.Alpha});
  grid-area: rating;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
`;

export const StoreRatingTitle = styled.p`
  ${BodyHeavy};
  margin-bottom: 10px;
`;

export const RatingLabelSkeleton = styled(TextSkeleton)`
  height: 20px;
  max-width: 251px;
  border-radius: 30px;
  margin-bottom: 8px;
`;

export const RatingSkeleton = styled(TextSkeleton)`
  height: 24px;
  max-width: 120px;
  border-radius: 30px;
`;
